/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function GradientRadialFarthestSide(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'GradientRadialFarthestSide',
      'aria-hidden': true,
      focusable: false,
      width:  17 * scale,
      height: 14 * scale,
      viewBox: '0 0 17 14',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"opacity":".5","fill":"#41A2F2","d":"M12 6.5C12 4.6 11.1 3 9.7 2H3.3c-.5.4-.9.8-1.3 1.3v6.3C3 11.1 4.6 12 6.5 12c3 0 5.5-2.5 5.5-5.5"}),createElement('path', {"fill":"#7AB8FF","d":"M6 7h9V6H6"}),createElement('circle', {"fill":"currentColor","cx":"6.5","cy":"6.5","r":"1.5"}),createElement('path', {"fill":"currentColor","d":"M15 1h1v12h-1z"}),createElement('path', {"opacity":".4","fill":"currentColor","d":"M2 12V2h13v10zM16 1H1v12h15z"}))
}
